import {
  GET_PREDICTED_SCORE_FAILED,
  GET_PREDICTED_SCORE_REQ,
  GET_PREDICTED_SCORE_SUCCESS,
  GET_TARGET_SCORE_FAILED,
  GET_TARGET_SCORE_REQ,
  GET_TARGET_SCORE_SUCCESS,
} from "../Constant/ScoreContacts";

export const PredictedScoreDataReducer = (state = {}, { type, payload }) => {
  switch (type) {
    case GET_PREDICTED_SCORE_REQ: {
      return { loading: true };
    }

    case GET_PREDICTED_SCORE_SUCCESS: {
      return { loading: false, PredictedScore: payload };
    }
    case GET_PREDICTED_SCORE_FAILED: {
      return { loading: false, error: payload };
    }
    default:
      return state;
  }
};

export const TargetScoreDataReducer = (state = {}, { type, payload }) => {
  switch (type) {
    case GET_TARGET_SCORE_REQ: {
      return { loading: true };
    }

    case GET_TARGET_SCORE_SUCCESS: {
      return { loading: false, TargetScore: payload };
    }

    case GET_TARGET_SCORE_FAILED: {
      return { loading: false, error: payload };
    }
    default:
      return state;
  }
};
